export default () => {
	const filterLinks = document.querySelectorAll('.catalog__category-link');

	filterLinks.forEach((link, index) => {
		const list = link.parentElement.querySelector('.catalog-filter__list');
		if (list) {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				e[`_isFilterDropDown${index}`] = true;
				if (!list.classList.contains('catalog-filter__list--show')) {
					list.classList.add('catalog-filter__list--show');
				} else {
					list.classList.remove('catalog-filter__list--show');
				}
				window.addEventListener('click', (e) => {
					if (!e[`_isFilterDropDown${index}`]) {
						list.classList.remove('catalog-filter__list--show');
					}
				});
			});
			const listItems = Array.from(list.children);
			listItems.forEach((item) => {
				item.addEventListener('click', (e) => {
					const activeLink = document.querySelector(
						'.catalog__category-link--active'
					);
					if (activeLink && activeLink === link) {
						return;
					}
					activeLink.classList.remove('catalog__category-link--active');
					link.classList.add('catalog__category-link--active');
				});
			});
		} else {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const activeLink = document.querySelector(
					'.catalog__category-link--active'
				);
				if (activeLink && activeLink === link) {
					return;
				}
				activeLink.classList.remove('catalog__category-link--active');
				link.classList.add('catalog__category-link--active');
			});
		}
	});
};
